export function toInteger(value: any): number {
  return parseInt(`${value}`, 10);
}

export function toString(value: any): string {
  return (value !== undefined && value !== null) ? `${value}` : '';
}

export function getValueInRange(value: number, max: number, min = 0): number {
  return Math.max(Math.min(value, max), min);
}

export function isString(value: any): value is string {
  return typeof value === 'string';
}

export function isNumber(value: any): value is number {
  return !isNaN(toInteger(value));
}

export function isInteger(value: any): value is number {
  return typeof value === 'number' && isFinite(value) && Math.floor(value) === value;
}

export function isDefined(value: any): boolean {
  return value !== undefined && value !== null;
}

export function isDate(value: any) {
  var matches = /^(\d+)\/(\d+)\/(\d+)$/.exec(value);
  if (!matches) {
    matches = /^(\d+)\-(\d+)\-(\d+)$/.exec(value);
    if (!matches) {
      return false;
    }
  }
  var y = parseInt(matches[1]);
  var m = parseInt(matches[2]);
  var d = parseInt(matches[3]);
  if (m < 1 || m > 12 || d < 1 || d > 31) {
    return false;
  }
  var dt = new Date(y, m - 1, d, 0, 0, 0, 0);
  if (dt.getFullYear() != y
    || dt.getMonth() != m - 1
    || dt.getDate() != d) {
    return false;
  }
  return true;
}

export function padNumber(value: number) {
  if (isNumber(value)) {
    return `0${value}`.slice(-2);
  } else {
    return '';
  }
}

export function regExpEscape(text) {
  return text.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&');
}

export function sjisByteLength(str: string): number {
  let length = 0;
  for (let i = 0; i < str.length; i++) {
    let c = str.charCodeAt(i);
    if ((c >= 0x0 && c < 0x81) || (c === 0xf8f0) || (c >= 0xff61 && c < 0xffa0) || (c >= 0xf8f1 && c < 0xf8f4)) {
      length += 1;
    } else {
      length += 2;
    }
  }
  return length;
}

export function insertcomma(params) {
  if (params.value === null) {
    params.value = 0;
  }
  var s = String(params.value).split('.');
  var ret = String(s[0]).replace( /(\d)(?=(\d\d\d)+(?!\d))/g, '$1,');
  if (s.length > 1) {
      ret += '.' + s[1];
  }
  return ret;
}

export function isAuthority(page, item?) {
  // let res = false;
  if (sessionStorage.getItem('loginResult')) {
    const loginResult = JSON.parse(sessionStorage.getItem('loginResult'));

    if (loginResult.user === null) {
      return false;
    }
    if (loginResult.user.roleId === null) {
      return false;
    }

    if (loginResult.user.roleId === 0) {
      return true;
    } else {
      if (loginResult.userroles === null) {
        return false;
      }
      for (let i = 0; i < loginResult.userroles.length; i++) {
        if (loginResult.userroles[i].DISPLAY_CD === page) {
          if (item) {//
            if (loginResult.userroles[i].FUNCTION_TX === item) {
              return true;
            }
          } else {
            return true;
          }
        }
      }
    }
  }
  return false;


}

  /**
   * CreateFormポスト用文字列生成
   * sessionKey:Post認証用セッションキー
   * jobId：帳票ジョブID（ファイル名の拡張子より前を想定）
   * serviceCd:サービスコード　※エンタープライズの場合必須。標準は空欄
   * 
   * @returns リクエスト文字列
   */
   export function getCreateFormRequest(sessionKey:string, jobId:string, reportCd:string, reporttrnId:string, serviceCode:string) {
     var queryString = 'sessionKey=' + sessionKey + '&jobId=' + jobId + '&reportCd=' + reportCd + '&serviceCode=' + serviceCode;
     if(reporttrnId != null && reporttrnId != undefined){
        queryString += '&reporttrnId=' + reporttrnId;
     }
    return queryString;
  }



// WEBPACK FOOTER //
// /home/runner/work/saas_wms_prod_ui_pc/saas_wms_prod_ui_pc/src/app/util/util.ts